import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { RoomProvider } from './context/RoomContext';
import { AuthProvider, useAuth } from './context/AuthContext';
import Home from './pages/Home';
import Room from './pages/Room';
import Login from './pages/Login';
import Register from './pages/Register';
import Profile from './pages/Profile';
import AdminDashboard from './pages/AdminDashboard';
import Meetings from './pages/Meetings';
import ScheduleMeeting from './pages/ScheduleMeeting';
import Rooms from './pages/Rooms';
import Salle from './pages/salle';
import RoomDetail from './pages/RoomDetail';
import JoinRoom from './pages/JoinRoom';
import JoinRoomPublic from './pages/JoinRoomPublic';
import WaitingRoom from './pages/WaitingRoom';
import ResetPassword from './pages/ResetPassword';
import About from './pages/About';
// Admin pages
import UserManagement from './pages/admin/UserManagement';
import MeetingStatistics from './pages/admin/MeetingStatistics';
import RolesManagement from './pages/admin/RolesManagement';
import AppSettings from './pages/admin/AppSettings';
import './App.css';

// Protected route wrapper - attend l'initialisation complète de l'auth
const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { user, loading, isInitialized } = useAuth();
  
  // Pendant l'initialisation (vérification token), afficher un loader
  if (!isInitialized || loading) {
    return (
      <div className="loading-container" style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: '#f5f5f5'
      }}>
        <div className="loading">Chargement...</div>
      </div>
    );
  }
  
  // Une fois initialisé, vérifier l'authentification
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  // Vérifier les droits admin si requis
  if (requireAdmin) {
    const isAdmin = user.role === 'admin' || user.role === 'Administrateur';
    if (!isAdmin) {
      return <Navigate to="/" replace />;
    }
  }
  
  return children;
};

// Public route - rediriger si déjà connecté
const PublicRoute = ({ children }) => {
  const { user, loading, isInitialized } = useAuth();
  
  // Pendant l'initialisation, afficher loader
  if (!isInitialized || loading) {
    return (
      <div className="loading-container" style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: '#f5f5f5'
      }}>
        <div className="loading">Chargement...</div>
      </div>
    );
  }
  
  // Si connecté, rediriger selon le rôle
  if (user) {
    if (user.role === 'Administrateur' || user.role === 'admin') {
      return <Navigate to="/admin" replace />;
    }
    return <Navigate to="/" replace />;
  }
  
  return children;
};

function App() {
  return (
    <AuthProvider>
      <RoomProvider>
        <Router>
          <div className="app">
            <Routes>
              <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
              <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />
               <Route path="/" element={<Home />} />
               <Route path="/about" element={<About />} />
               <Route path="/room/:roomId" element={<Room />} />
              <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
              <Route path="/meetings" element={<ProtectedRoute><Meetings /></ProtectedRoute>} />
              <Route path="/schedule" element={<ProtectedRoute><ScheduleMeeting /></ProtectedRoute>} />
              <Route path="/rooms" element={<ProtectedRoute><Rooms /></ProtectedRoute>} />
              <Route path="/salle" element={<ProtectedRoute><Salle /></ProtectedRoute>} />
              <Route path="/rooms/:roomId" element={<ProtectedRoute><RoomDetail /></ProtectedRoute>} />
              <Route path="/rooms/join/:token" element={<JoinRoom />} />
              <Route path="/join/:roomId" element={<JoinRoomPublic />} />
              <Route path="/rooms/:roomId/waiting" element={<WaitingRoom />} />
               <Route path="/reset-password/:token" element={<ResetPassword />} />
              <Route path="/admin" element={<ProtectedRoute requireAdmin={true}><AdminDashboard /></ProtectedRoute>} />
              <Route path="/admin/users" element={<ProtectedRoute requireAdmin={true}><UserManagement /></ProtectedRoute>} />
              <Route path="/admin/statistics" element={<ProtectedRoute requireAdmin={true}><MeetingStatistics /></ProtectedRoute>} />
              <Route path="/admin/roles" element={<ProtectedRoute requireAdmin={true}><RolesManagement /></ProtectedRoute>} />
              <Route path="/admin/settings" element={<ProtectedRoute requireAdmin={true}><AppSettings /></ProtectedRoute>} />
            </Routes>
          </div>
        </Router>
      </RoomProvider>
    </AuthProvider>
  );
}

export default App;
